import 'react-toastify/dist/ReactToastify.css'

import { useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Outlet } from 'react-router-dom'

import { Loading } from '../components'
import Navbar from '../components/app/Navbar'
import SideBar from '../components/app/SideBar'
import ErrorPage from '../pages/ErrorPage'
import { useAppSelector } from '../store/hooks'

const AppContainer = () => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false)
  const switchSideBar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const { loading } = useAppSelector((state) => state.init)
  const { staticBar } = useAppSelector((state) => state.session)

  if (loading) return <Loading />
  return (
    <div className="h-full w-full">
      <ErrorBoundary fallback={<ErrorPage />}>
        <Navbar />
        <SideBar barState={sidebarOpen} switchSideBar={switchSideBar} />
        <div
          className={`fixed w-full ${
            staticBar ? 'md:pl-64' : 'md:pl-20'
          } h-full pt-24 md:pt-16`}
        >
          <main className="h-full overflow-auto py-5 scrollbar-thin scrollbar-thumb-gray-300 sm:px-2 md:px-4 lg:px-8">
            <Outlet />
          </main>
        </div>
      </ErrorBoundary>
    </div>
  )
}

export default AppContainer
